import { cn } from "@/lib/utils";

/**
 * Centralized styling utilities for navigation components
 * Ensures consistent styling across all navigation elements
 */

/**
 * Get className for navigation item button
 */
export const getNavItemClassName = (
    isPageActive: boolean,
    isDropdownActive: boolean
): string => {
    return cn(
        "flex w-full items-center justify-center gap-2 rounded-full px-4 py-2",
        "text-sm font-medium transition-colors",
        isPageActive
            ? "bg-black text-white dark:bg-white dark:text-black"
            : "text-text-primary hover:bg-secondary-hover",
        isDropdownActive && !isPageActive && "bg-secondary-hover"
    );
};

/**
 * Get className for dropdown container
 */
export const getDropdownContainerClassName = (
    isContentCuration: boolean
): string => {
    return cn(
        "absolute left-0 top-full z-[101] pt-3",
        "duration-300 animate-in fade-in slide-in-from-top-2",
        isContentCuration ? "flex min-w-[680px] gap-6" : "min-w-[240px]"
    );
};

/**
 * Get className for dropdown content wrapper
 */
export const getDropdownContentClassName = (
    isContentCuration: boolean
): string => {
    return cn(
        "mt-4 rounded-[20px] bg-black/40 dark:bg-black/60",
        "border border-white/15",
        isContentCuration ? "flex gap-6 p-6" : "p-3"
    );
};

/**
 * Dropdown styling constants
 */
export const DROPDOWN_STYLES = {
    backdropFilter: "blur(24px) saturate(180%)",
    boxShadow:
        "0 20px 60px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1) inset"
};

/**
 * Get animation delay for staggered animations
 */
export const getStaggerDelay = (
    columnIndex: number,
    itemIndex: number = 0
): string => {
    return `${columnIndex * 0.08 + itemIndex * 0.04}s`;
};

/**
 * Get className for dropdown item
 */
export const getDropdownItemClassName = (isSelected: boolean): string => {
    return cn(
        "group/item relative overflow-hidden rounded-lg transition-all duration-300 ease-out",
        isSelected
            ? "bg-black dark:bg-red-400"
            : "hover:bg-white/10 dark:hover:bg-white/5"
    );
};
